import { DashboardPage } from '@components-common/layouts';
import { ScreenProps } from '@components-common/types';
import { ConfigElement } from '@components-fabric/types';
import { mapWidgets } from './widget';
import { mapView } from './view';

export const mapDashboardScreen = (
  config: ConfigElement,
  context: ScreenProps
) => {
  const result = {
    type: 'dashboard',
    view: {
      ...mapView(config, context),
      Component: DashboardPage,
      ...{
        props: {
          widgets: mapWidgets(config, context),
        },
      },
    },
  };
  return result;
};
